<template>
    <b-modal ref="modal" :visible="visible" size="lg" no-close-on-backdrop no-close-on-esc modal-class="visitpass-modal">
        <div slot="modal-header" class="w-100">
            <h5>{{ title }}
                <button type="button" class="close" @click.prevent="closeModal()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </h5>
        </div>
        <div class="text-center">
            <h3>Connect a device with QPass</h3>
            <img class="qpass" :src="url"/>
        </div>
        <div slot="modal-footer" class="w-100">
            <button type="button" class="btn btn-outline-orange mr-2 float-right" @click.prevent="closeModal()">Close</button>
        </div>
    </b-modal>
</template>

<script>
  export default {
    name: 'PdfViewModal',

    props: {
      visible: {
        type: Boolean,
        required: true
      },

      title: {
        type: String,
        required: true
      },

      url: {
        type: String,
        required: true
      }
    },

    data () {
      return {
      }
    },

    methods: {
      closeModal () {
        this.$emit('update:visible', false)
      }
    }
  }
</script>

<style>
  .qpass {
      max-height: 450px;
  }
</style>
